var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 18,
    viewBox: "0 0 17.999 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "broom-svgrepo-com",
    d: "M1.381,9.69a.607.607,0,0,0-.2.991L3.1,12.607l2.573-.858-.858,2.573,4.5,4.5a.605.605,0,0,0,.991-.2l3.448-8.566-3.81-3.81L1.381,9.69ZM18.833,1.96l-.794-.794a.558.558,0,0,0-.794,0l-3.6,3.592-1.42-1.42a.3.3,0,0,0-.489.088l-.956,2.06,3.729,3.729,2.06-.956a.3.3,0,0,0,.088-.489l-1.42-1.42,3.592-3.6a.558.558,0,0,0,0-.794Z",
    transform: "translate(-1 -1)",
    fill: "#3872b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroom);
export default __webpack_public_path__ + "static/media/broom.7632dbf93e21b9d037bcd9fde210fda1.svg";
export { ForwardRef as ReactComponent };